import { IBusStop } from "@/domain/entities/busStop";
import { ITurn } from "@/domain/entities/lineInfo";
import isDateWithinPeriod from "./useIsDateWithinPeriod";

/** 특정 일자에 사용중인 정류장 목록을 찾는 함수 */
export default function getBusStopsByDate(
  turn: ITurn,
  date: string
): IBusStop[] {
  const targetBusStops = turn.busStopGroupsByPeriod?.find((busStopGroup) =>
    isDateWithinPeriod(date, busStopGroup.useBeginDtm, busStopGroup.useEndDtm)
  );

  return targetBusStops ? targetBusStops.busStops : turn.busStops;
}
